import { render, staticRenderFns } from "./InformationDetails.vue?vue&type=template&id=d28a4cd4&scoped=true&"
import script from "./InformationDetails.vue?vue&type=script&lang=js&"
export * from "./InformationDetails.vue?vue&type=script&lang=js&"
import style0 from "../../assets/informationDetails.css?vue&type=style&index=0&id=d28a4cd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28a4cd4",
  null
  
)

export default component.exports